/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SecondFactorStateDto = {
    None: 'None',
    Active: 'Active',
    Unknown: 'Unknown'
} as const;
export type SecondFactorStateDto = typeof SecondFactorStateDto[keyof typeof SecondFactorStateDto];


export function instanceOfSecondFactorStateDto(value: any): boolean {
    for (const key in SecondFactorStateDto) {
        if (Object.prototype.hasOwnProperty.call(SecondFactorStateDto, key)) {
            if (SecondFactorStateDto[key as keyof typeof SecondFactorStateDto] === value) {
                return true;
            }
        }
    }
    return false;
}

export function SecondFactorStateDtoFromJSON(json: any): SecondFactorStateDto {
    return SecondFactorStateDtoFromJSONTyped(json, false);
}

export function SecondFactorStateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SecondFactorStateDto {
    return json as SecondFactorStateDto;
}

export function SecondFactorStateDtoToJSON(value?: SecondFactorStateDto | null): any {
    return value as any;
}

export function SecondFactorStateDtoToJSONTyped(value: any, ignoreDiscriminator: boolean): SecondFactorStateDto {
    return value as SecondFactorStateDto;
}

